/**
 * @file
 * Sticky Menu.
 */

((Drupal, drupalSettings, document, window) => {
  /**
   * Attach the sticky behavior.
   *
   * @type {Drupal~behavior}
   *
   * @prop {Drupal~behaviorAttach} attach
   *   Attaches the sticky behavior.
   */
  Drupal.behaviors.stickyMenu = {
    attach(context) {
      if (context === document) {
        this.init();
      }
    },

    /**
     * Initialise the behavior.
     */
    init() {
      if (document.querySelector(".sidebar-menu") != null) {
        this.bindEventHandlers();
      }
    },

    /**
     * Bind the event handlers.
     */
    bindEventHandlers() {
      const sideMenuLinks = document.querySelectorAll(".sidebar-menu ul li");
      const sidebarMenu = document.querySelector(".sidebar-menu");
      const sidebarList = document.querySelector(".sidebar-menu__list");
      const siteFooter = document.querySelector(".site-footer");
      const sidebarInitialPosition = sidebarMenu.offsetTop;
      const stopPosition = siteFooter.offsetTop - 600;

      // Function to make IE9+ support forEach:
      if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = Array.prototype.forEach;
      }

      const firstMenuLink = sideMenuLinks[0];
      const firstLink = firstMenuLink.querySelector("a");
      const firstSection = document.querySelector(firstLink.hash);
      firstMenuLink.classList.add("active");

      if (!drupalSettings.removeStickiness) {
        window.addEventListener("scroll", (event) => {
          const fromTop = window.scrollY;

          if (fromTop >= stopPosition) {
            if (sidebarList.classList.contains("sticky")) {
              sidebarList.classList.remove("sticky");
              sidebarList.style.position = "relative";
              sidebarList.style.top = `${stopPosition - 600}px`;
            }
          } else if (fromTop <= sidebarInitialPosition) {
            if (sidebarList.classList.contains("sticky")) {
              sidebarList.classList.remove("sticky");
              sidebarList.style.position = "relative";
              sidebarList.style.top = "initial";
            }
          } else if (fromTop > sidebarInitialPosition) {
            if (!sidebarList.classList.contains("sticky")) {
              sidebarList.classList.add("sticky");
              sidebarList.style.position = null;
              sidebarList.style.top = null;
            }
          }

          // Set active class while scrolling.
          sideMenuLinks.forEach((listItem) => {
            const link = listItem.querySelector("a");
            const section = document.querySelector(link.hash);
            let sectionPosition = 0;

            const parentPosition = this.hasSomeParentTheClass(
              section,
              "container"
            );
            if (parentPosition != null) {
              sectionPosition = section.offsetTop + parentPosition;
            } else {
              sectionPosition = section.offsetTop;
            }

            if (
              sectionPosition <= fromTop &&
              sectionPosition + section.offsetHeight > fromTop
            ) {
              listItem.classList.add("active");
            } else if (firstSection.offsetTop + 440 >= fromTop) {
              firstMenuLink.classList.add("active");
            } else {
              listItem.classList.remove("active");
            }
          });
        });
      } else {
        let i;
        for (i = 0; i < sideMenuLinks.length; i++) {
          sideMenuLinks[i].addEventListener("click", function () {
            if (!this.classList.contains("active")) {
              sideMenuLinks.forEach((listItem) => {
                listItem.classList.remove("active");
              });
              this.classList.toggle("active");
            }
          });
        }
      }
    },

    /**
     * Detect if an element has a parent with specific class name.
     *
     * @param {HTMLElement} element
     *   Element to check.
     * @param {HTMLElement} className
     *   Class name that parent must have.
     *
     * @return {number}
     *   Return position of parent.
     */
    hasSomeParentTheClass(element, className) {
      if (
        element.className &&
        element.className.split(" ").indexOf(className) >= 0
      ) {
        return element.offsetTop;
      }

      return (
        element.parentNode &&
        this.hasSomeParentTheClass(element.parentNode, className)
      );
    },
  };
})(Drupal, drupalSettings, document, window);
